<template>
<div class="investor-body">
	<section>
		<div>
			<slot></slot>
		</div>
	</section>
</div>

</template>

<script>

export default {

	name: "InvestorBody"

}

</script>